<div
  class="file-upload input"
  ftrFileDrop
  (onIsReadyToDrop)="setFileReadyToDrop($event)"
  (onFilesDropped)="uploadFiles($event)"
>
  <ftr-drop-overlay [isReadyToDrop]="isReadyToDrop">{{ dropOverlayText }}</ftr-drop-overlay>
  <div class="file-upload__drop-area">
    <p>
      Drag and drop
      {{ maxFiles === 1 ? 'a file' : maxFiles ? 'up to ' + maxFiles + ' files' : 'files' }} here
    </p>
    <p>or</p>
    <ftr-file-selector
      class="file-upload__select input__control input__control--has-value"
      [enabled]="uploadEnabled"
      [primary]="false"
      [multiple]="uploadSlotsRemaining > 1"
      [buttonDisplayType]="buttonDisplayType.Text"
      label="Browse files"
      (fileAdded)="uploadFile($event)"
      [acceptableFileExtensions]="acceptableFileExtensions"
    ></ftr-file-selector>
  </div>
  @if (uploads$ | async; as uploads) {
    @if (uploads.length > 0) {
      <div class="file-upload__list">
        @for (upload of uploads; track uploadTrackBy($index, upload); let first = $first; let last = $last) {
          <div [attr.aria-label]="'Upload ' + upload.id" [@fade]>
            <ftr-file-upload-item
              [fileToUpload]="upload"
              [sizeLimit]="sizeLimit"
              [acceptableFileExtensions]="acceptableFileExtensions"
              [fileUploadService]="fileUploadService"
              [fileOrder]="first ? fileOrder.First : last ? fileOrder.Last : fileOrder.Middle"
              (uploadStatusChange)="updateUploadStatus($event)"
            ></ftr-file-upload-item>
          </div>
        }
      </div>
    }
  }
</div>
